/**
 * /billing/invoices — platform-wide invoice ledger (PLATBILL-07).
 *
 * Renders the all-tenants invoices table + record-payment dialog; sits under
 * the BillingHubLayout outlet alongside Plans / Subscriptions / MRR.
 */
import { createFileRoute } from "@tanstack/react-router";
import { PlatformInvoicesScreen } from "../features/billing/PlatformInvoicesScreen";

export const Route = createFileRoute("/_auth/billing/invoices")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:billing.hub.tabs.invoices" },
  },
  component: PlatformInvoicesScreen,
});
